import { render, staticRenderFns } from "./back-deliveryreceipt-scan.vue?vue&type=template&id=4970a179&scoped=true&"
import script from "./back-deliveryreceipt-scan.vue?vue&type=script&lang=ts&"
export * from "./back-deliveryreceipt-scan.vue?vue&type=script&lang=ts&"
import style0 from "./back-deliveryreceipt-scan.vue?vue&type=style&index=0&id=4970a179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4970a179",
  null
  
)

export default component.exports